import Context from "../context/context";
import React, { useContext } from 'react';

import Checkbox from "./Checkbox";


function Checkboxes(props){
    const {data} = props;
    const {selectedFilters, setSelectedFilters} = useContext(Context);
    
    const handleCheckboxClick = (id) => {
        
        let updated_filters = selectedFilters.map((selected_filter) => {
            if (selected_filter.name === data.name){
                selected_filter.elements.forEach((element) => {
                    if (element.id === id) {
                        element.value = !element.value;
                    } 
                })
            }
            return selected_filter;
        })
        setSelectedFilters(updated_filters);
    }
    

    
    return (
        <>
            <div className="checkboxes">
                {
                    data.elements.map(element => 
                        <Checkbox key={element.id} data={element} handleClick={() => handleCheckboxClick(element.id)} />
                    )
                }
            </div>

 
        </>
    )
}

export default Checkboxes;